import moment from "moment-timezone";
import { Order } from "../types/order";
import { ProductsById } from "../types/product";
import { LineItemWithProdType } from "../types/line-items";

const formatDate = (timestamp: number): string => {
  const unixMoment = moment.unix(timestamp).tz("Asia/Riyadh");

  if (unixMoment > moment().tz("Asia/Riyadh").startOf("D")) {
    const fullTime = unixMoment.format("h:mm a");
    return `${fullTime} - ${unixMoment.fromNow()}`;
  }
  const fullDate = unixMoment.format("D/M/YYYY");
  return `${fullDate} - ${unixMoment.fromNow()}`;
};

const getLineItemCount = (currentOrder: Order): number => {
  if (!currentOrder?.items) return 0;
  const itemCount = currentOrder.items.reduce((count, item) => {
    count += item.quantity;
    return count;
  }, 0);
  return itemCount;
};

const getLineItems = (
  currentOrder: Order,
  productsById: ProductsById | null,
): LineItemWithProdType[] => {
  const items = currentOrder.items || [];
  return items.map((item, index) => {
    const title =
      productsById && productsById[item.productId]
        ? productsById[item.productId]?.name
        : "";
    return {
      ...item,
      id: `${index}`,
      productId: `${item.productId}`,
      title,
      total: item.total,
    } as LineItemWithProdType;
  });
};

export { getLineItemCount, formatDate, getLineItems };
